import React from 'react';
import Toast from 'react-bootstrap/Toast';

export default function ToastNotification(props) {

    return (
        <div>
            <div style={{
                width: window.innerWidth > 767 ? '' : '100%',
                position: 'absolute', zIndex: 13, left: '50%',
                transform: 'translate(-50%, 0px)'
            }}>
                <Toast show={props.show} className="d-inline-block m-1" bg={'Danger'.toLowerCase()} >
                    <div style={{ position: 'absolute', top: 12, right: window.innerWidth > 767 ? 12 : 50 }} onClick={props.setClose}>
                        <img
                            src="/images/close-white.svg"
                            width={15}
                            alt=""
                            className='cursor-pointer'
                        />

                    </div>
                    <Toast.Body style={{ padding: '1.75rem', fontSize: 18 }} className={'Danger' && 'text-white'}>
                        {props.message}
                    </Toast.Body>
                </Toast>
            </div>
        </div >
    )
}
